export const UPDATE_ENTRY_STRATEGY = 'UPDATE_ENTRY_STRATEGY';
export const UPDATE_ENTRY_STRATEGY_SUCCESS = 'UPDATE_ENTRY_STRATEGY_SUCCESS';
export const UPDATE_ENTRY_STRATEGY_FAILURE = 'UPDATE_ENTRY_STRATEGY_FAILURE';
